var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenDoneButton({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9C0 4.02891 4.02891 0 9 0C13.9711 0 18 4.02891 18 9C18 13.9711 13.9711 18 9 18C4.02891 18 0 13.9711 0 9ZM13.0711 7.44609C13.4543 7.06289 13.4543 6.43711 13.0711 6.05391C12.6879 5.6707 12.0621 5.6707 11.6789 6.05391L7.875 9.85781L6.32109 8.30391C5.93789 7.9207 5.31211 7.9207 4.92891 8.30391C4.5457 8.68711 4.5457 9.31289 4.92891 9.69609L7.17891 11.9461C7.56211 12.3293 8.18789 12.3293 8.57109 11.9461L13.0711 7.44609Z",
    fill: "#4BB218"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenDoneButton);
export default __webpack_public_path__ + "static/media/GreenDoneButton.ecb1f57b747562d7afad0c005616735a.svg";
export { ForwardRef as ReactComponent };